import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as ReactHelmetAsync from 'react-helmet-async';
import './index.css';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const HelmetProvider = ReactHelmetAsync.HelmetProvider || (ReactHelmetAsync as any).default?.HelmetProvider;
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <HelmetProvider>
      {children}
    </HelmetProvider>
  );
}